var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 254.76674,
    viewBox: "0 0 132.29165 67.40703",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(3.7666925e-6,-229.59284)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D5 \\uE1E7       \\uE1D7",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4148",
    transform: "matrix(7.8341557,0,0,7.8341557,-170.01906,-1418.2097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4154",
    style: {
      strokeWidth: 2.38434362
    },
    d: "m 37.61515,212.71694 c -0.433916,-0.66675 -0.79375,-1.36525 -0.92075,-2.18017 -0.03175,-0.13758 -0.09525,-0.17991 -0.254,-0.17991 -0.04233,0 -0.08467,0.0106 -0.08467,0.0741 v 0.0106 c 0,0 0,0.0212 0,0.0423 v 1.98966 c 0,0 0,0 0,0 v 4.27567 c -0.169334,-0.14817 -0.402167,-0.22225 -0.677334,-0.22225 -1.04775,0 -1.883833,0.77258 -1.883833,1.5875 0,0.49742 0.402167,0.79375 0.92075,0.79375 0.846667,0 1.894417,-0.78317 1.894417,-1.5875 v -4.75192 c 0.518583,0.32809 1.143,1.25942 1.407583,1.87325 0.127,0.28575 0.201083,0.77259 0.201083,1.27 0,0.381 -0.05292,0.78317 -0.201083,1.16417 -0.01058,0.0423 -0.02117,0.0847 -0.02117,0.127 0,0.127 0.08467,0.21167 0.137584,0.24342 l 0.01058,0.0106 c 0.07408,0 0.179917,-0.0318 0.22225,-0.16933 0,0 0.22225,-0.80434 0.22225,-1.47109 0,-1.05833 -0.4445,-2.05316 -0.973667,-2.89983 z m -11.200804,5.02708 c 0,-0.23283 -0.1905,-0.42333 -0.423334,-0.42333 -0.232833,0 -0.423333,0.1905 -0.423333,0.42333 0,0.23284 0.1905,0.42334 0.423333,0.42334 0.232834,0 0.423334,-0.1905 0.423334,-0.42334 z m -2.150897,-0.97366 c -0.169334,-0.14817 -0.402167,-0.22225 -0.677334,-0.22225 -1.04775,0 -1.883833,0.77258 -1.883833,1.59808 0,0.49742 0.402167,0.79375 0.92075,0.79375 0.846667,0 1.894417,-0.79375 1.894417,-1.59808 v -7.00617 h -0.254 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQde);
export default __webpack_public_path__ + "static/media/qde.90e7292af8ce721efa22e04fa8448382.svg";
export { ForwardRef as ReactComponent };